module.exports = __webpack_public_path__ + "img/calendar-events-active.e30b4110.svg";